import { initLoadable } from '@/store/utils'
import type { Loadable } from '@/store/utils'
import type { Study, API } from '@pocketprep/types'

/** Server 2.0 mockExams type with objectId for backwards compatibility */
export type ClientMockExam = API.MockExam & {
    objectId: string
}

/** Server 2.0 exam type with
 *  objectId, object sunsetAt,
 *  and hydrated mockExams list for backwards compatibility */
export type ClientExam = Omit<API.ExamMetadata, 'mockExams' | 'mockExamIds' | 'sunsetAt'> & {
    objectId: string
    sunsetAt?: { iso: string }
    mockExams: ClientMockExam[]
}

/** Server 2.0 bundle type with objectId and hydrated exams list for backwards compatibility */
export type ClientBundle = Omit<API.Bundle, 'exams' | 'examMetadataIds'> & {
    objectId: string
    exams: ClientExam[]
}

/** Server 2.0 response types with objectId and hydration backwards compatibility */
export type ClientBundlesResponse = {
    mockExams: ClientMockExam[]
    exams: ClientExam[]
    bundles: ClientBundle[]
}

type TBundleState = {
    bundles: Loadable<Study.Class.BundleJSON[] | ClientBundle[]>
}

export const getInitialBundleState = (): TBundleState => {
    return {
        bundles: initLoadable([]),
    }
}

const moduleState = getInitialBundleState()

export default moduleState
